import { soloSessionCreationKeys } from './constants';
import {
  MobileCameraIcon,
  MobileDocumentIcon,
  MobileListIcon,
} from '../MobileSoloPortal/MobileSoloPortalIcons';

// Icon imports
import convertIcon from '../../assets/convert.svg';
import bulbIcon from '../../assets/bulb.svg';
import noteIcon from '../../assets/zyncup.svg';
import zyncupIcon from '../../assets/note.svg';

export const soloSessionCreationOptions = [
  {
    itemKey: soloSessionCreationKeys?.manualScript,
    title: (
      <p>
        <span>Start with a Script</span>
        <span className="font-light text-[13px] text-[#696F8C] text-sm block">
          Craft a video based on your script.
        </span>
      </p>
    ),
    aiSuggest: false,
    disabled: false,
    icon: <img src={noteIcon} alt="note icon" />,
    header: 'Start with a Script',
    description: 'Craft a video based on your script.',
    mobileIcon: <MobileListIcon />,
  },
  {
    itemKey: soloSessionCreationKeys?.idea,
    title: (
      <p>
        <span>Turn Idea to Video</span>
        <span className="font-light text-[13px] text-[#696F8C] text-sm block">
          From simple idea to video script.
        </span>
      </p>
    ),
    aiSuggest: true,
    disabled: false,
    icon: <img src={bulbIcon} alt="bulb icon" />,
    header: 'Turn Idea to Video',
    description: 'From simple idea to video script.',
    mobileIcon: <MobileCameraIcon />,
  },
  {
    itemKey: soloSessionCreationKeys?.blogPost,
    title: (
      <p>
        <span>Convert Existing Content</span>
        <span className="font-light text-[13px] text-[#696F8C] text-sm block">
          From a blog, LinkedIn post, or newsletter.
        </span>
      </p>
    ),
    aiSuggest: true,
    disabled: false,
    icon: <img src={convertIcon} alt="note icon" />,
    header: 'Convert Existing Content',
    description: 'From a blog, LinkedIn post, or newsletter.',
    mobileIcon: <MobileDocumentIcon />,
  },
  {
    itemKey: soloSessionCreationKeys?.zyncup,
    title: (
      <p>
        <span className="whitespace-nowrap">Create ZyncUp Question</span>
        <span className="font-light text-[13px] text-[#696F8C] text-sm block">
          Create collaborative videos with others
        </span>
      </p>
    ),
    aiSuggest: false,
    disabled: false,
    icon: <img src={zyncupIcon} alt="zync up question" />,
    header: 'Create ZyncUp Question',
    description: 'Create collaborative videos with others',
    mobileIcon: <MobileListIcon />,
    mobileHeader: 'Create a ZyncUp question',
    linkText: 'What is ZyncUp?',
    link: 'https://www.zync.ai/lessons/zyncup-combine-videos-share-audiences',
  },
];
